import React from 'react';
import { Box } from '@mui/material';
import { ReactComponent as GoogleDriveIcon } from '../../../../assets/uploadFile-assets/google-drive.svg';
import { ReactComponent as OneDriveIcon } from '../../../../assets/uploadFile-assets/one-drive.svg';
import { ReactComponent as SharePointIcon } from '../../../../assets/uploadFile-assets/sharepoint.svg';
import { ReactComponent as GmailIcon } from '../../../../assets/uploadFile-assets/gmail.svg';
import { ReactComponent as OutlookIcon } from '../../../../assets/uploadFile-assets/outlook.svg';
import { ReactComponent as DocutranscribeIcon } from '../../../../assets/common-assets/logoIcon.svg';
import { ReactComponent as Zoho } from '../../../../assets/common-assets/zoho.svg';
import { ReactComponent as Odoo } from '../../../../assets/common-assets/odoo.svg';
import { ReactComponent as Xero } from '../../../../assets/common-assets/xero.svg';
import { ReactComponent as QuickBook } from '../../../../assets/common-assets/quickBook.svg';
import { ReactComponent as Tally } from '../../../../assets/common-assets/tally.svg';
import { classes } from './utils';

export const checkDocutranscribeNode = (allNode, allEdge, type) => {
  const docutranscribeNodeId = allNode.find(
    (node) => node.data.label === 'Docutranscribe',
  )?.id;

  if (!docutranscribeNodeId) {
    return false;
  }

  return allEdge.some(
    (edge) =>
      edge.target === docutranscribeNodeId && edge.source.startsWith(type),
  );
};

const icons = {
  Gmail: (
    <Box className={classes.connectionBoxStyle}>
      <GmailIcon className={classes.connectionLogoStyle} />
    </Box>
  ),
  Docutranscribe: (
    <Box className={classes.connectionBoxStyle}>
      <DocutranscribeIcon className={classes.connectionLogoStyle} />
    </Box>
  ),
  GoogleDrive: (
    <Box className={classes.connectionBoxStyle}>
      <GoogleDriveIcon className={classes.connectionLogoStyle} />
    </Box>
  ),
  OneDrive: (
    <Box className={classes.connectionBoxStyle}>
      <OneDriveIcon className={classes.connectionLogoStyle} />
    </Box>
  ),
  SharePoint: (
    <Box className={classes.connectionBoxStyle}>
      <SharePointIcon className={classes.connectionLogoStyle} />
    </Box>
  ),
  Outlook: (
    <Box className={classes.connectionBoxStyle}>
      <OutlookIcon className={classes.connectionLogoStyle} />
    </Box>
  ),
  Zoho: (
    <Box className={classes.connectionBoxStyle}>
      <Zoho className={classes.connectionLogoStyle} />
    </Box>
  ),
  Odoo: (
    <Box className={classes.connectionBoxStyle}>
      <Odoo className={classes.connectionLogoStyle} />
    </Box>
  ),
  Xero: (
    <Box className={classes.connectionBoxStyle}>
      <Xero className={classes.connectionLogoStyle} />
    </Box>
  ),
  QuickBook: (
    <Box className={classes.connectionBoxStyle}>
      <QuickBook className={classes.connectionLogoStyle} />
    </Box>
  ),
  TallyPrime: (
    <Box className={classes.connectionBoxStyle}>
      <Tally className={classes.connectionLogoStyle} />
    </Box>
  ),
};

export const CustomStepIcon = (props) => {
  const { icon: connections } = props;
  return icons[connections];
};
